import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionIdService } from './session-id.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly sessionIdService: SessionIdService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const sessionId = this.sessionIdService.getSessionId();

    const clonedRequest = req.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'x-session-id': sessionId
      }
    });

    return next.handle(clonedRequest);
  }
}